import { useEffect, useState } from "react";
import { useDocument } from "./useDocument";
export const defaultCulture = "en-gb";
const useDetectCurrentCulture = () => {
    const myDocument = useDocument();
    const [culture, setCulture] = useState("");
    const checkCurrentCulture = () => {
        var _a;
        const bodyEl = myDocument.querySelector("body");
        const parsedCulture = (_a = bodyEl === null || bodyEl === void 0 ? void 0 : bodyEl.getAttribute("data-lang")) === null || _a === void 0 ? void 0 : _a.toLowerCase();
        setCulture(parsedCulture || defaultCulture);
    };
    useEffect(() => {
        myDocument && checkCurrentCulture();
    }, [myDocument]);
    return {
        culture,
        defaultCulture
    };
};
export default useDetectCurrentCulture;
